<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<h2 class="back-btn">基本资料</h2>
	</div>
	<div class="ld-panel-main">
		<el-alert title="请完善以下信息，方便我们更好的为您服务！" type="warning" show-icon :closable="false" />
		<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" :label-width="formLabelWidth" class="form-main">
			<h4 class="form-cloumn">基本信息</h4>
			<el-form-item label="会员ID">
				<el-input v-model="userid" disabled />
			</el-form-item>
			<el-form-item label="所在地区" prop="cityId">
				<area-picker :areaData="areaData" @prvChange="prvChange" @cityChange="cityChange" @districtChange="districtChange" />
			</el-form-item>
			<el-form-item label="详细地址" prop="address">
				<el-input v-model="groupForm.address" autocomplete="off" />
			</el-form-item>
			<el-form-item label="手机号码">
				<el-input v-model="mobile" disabled />
				<router-link to="/account/mobile" style="margin-left: 10px;">修改</router-link>
			</el-form-item>
			<el-form-item label="电子邮箱">
				<el-input v-model="email" disabled />
				<router-link to="/account/email" style="margin-left: 10px;">修改</router-link>
			</el-form-item>
			<el-form-item label="QQ号码" prop="qq">
				<el-input v-model="groupForm.qq" autocomplete="off" />
			</el-form-item>
			<h4 class="form-cloumn">业务信息</h4>
			<el-form-item label="主要行业应用" prop="pwd">
				<ul class="ul-industry">
					<li v-for="(item, index) in industryOptions" :key="index" @click="industryChange(item.key)" :class="{ 'active': selectedIndustry === item.key }">{{item.name}}</li>
				</ul>
			</el-form-item>
			<el-form-item label="主营业务" prop="mainBusiness">
				<el-input v-model="groupForm.mainBusiness" autocomplete="off" />
			</el-form-item>
			<el-form-item label="网站地址">
				<el-input v-model="groupForm.webAddress" autocomplete="off" />
			</el-form-item>
			<el-form-item label="促销邮件">
				<el-switch v-model="groupForm.is_promo_email" /><span class="tip">同意接收公司发送的促销邮件,接收促销邮件可以及时了解到我司最新的促销信息</span>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import Cookies from 'js-cookie';
	import { getUserInfo,getconstinfo,updateInfo } from '@/api/account';
	import sideNav from '../../components/sideNav.vue';
	import areaPicker from '../../components/areaPicker.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const pageTitle = 'account';
	const formLabelWidth = ref('160px');
	const userid = ref('');
	const mobile = ref('');
	const email = ref('');
	const industryOptions = ref();
	const selectedIndustry = ref('');
	const prvObj = ref('');
	const cityObj = ref('');
	const districtObj = ref('');
	const prvId = ref(0);
	const cityId = ref(0);
	const districtId = ref(0);
	const prv = ref('');
	const city = ref('');
	const district = ref('');
	const areaData = ref([]);
	const ruleFormRef = ref(null);
	const groupForm = ref({address:'',qq:'',mainBusiness:'',webAddress:'',is_promo_email:0});
	const rules = reactive({
		address: [
			{ required: true, message: '请填写详细地址', trigger: 'blur' }
		],
		qq: [
			{ required: true, message: '请填写QQ号码', trigger: 'blur' }
		],
		mainBusiness: [
			{ required: true, message: '请填写主营业务', trigger: 'blur' }
		]
	});
	
	
	const getUserInfoF = () => {
		getconstinfo('industry').then((res) => {
			industryOptions.value = Object.entries(res.data).map(([key, name]) => ({
			  key: parseInt(key, 10),
			  name: name
			}));
			if(selectedIndustry.value == ''){
				selectedIndustry.value = industryOptions.value[0].key
			}
		})
		getUserInfo().then((res) => {
			if(res.code === 200){
				if (res.data.prvId !== 0) {
					areaData.value.push(
						{ key: res.data.prvId.toString(), value: res.data.prv },
						{ key: res.data.cityId.toString(), value: res.data.city },
						{ key: res.data.districtId.toString(), value: res.data.district }
					);
				}
				prvId.value = res.data.prvId;
				cityId.value = res.data.cityId;
				districtId.value = res.data.districtId;
				prv.value = res.data.prv;
				city.value = res.data.city;
				district.value = res.data.district;
				userid.value = res.data.username;
				mobile.value = res.data.mobileEncrypt;
				email.value = res.data.emailEncrypt;
				selectedIndustry.value = res.data.crmIndustry == 0 ? selectedIndustry.value : res.data.crmIndustry;
				groupForm.value.address = res.data.address;
				groupForm.value.qq = res.data.qq;
				groupForm.value.mainBusiness = res.data.mainBusiness;
				groupForm.value.webAddress = res.data.webAddress;
				groupForm.value.is_promo_email = res.data.is_promo_email;
				
			}
		})
	};
	const industryChange = (key) => {
		selectedIndustry.value = key;
	};
	const prvChange = (val) =>{
		prvObj.value = val
	};
	const cityChange = (val) =>{
		cityObj.value = val
	};
	const districtChange = (val) =>{
		districtObj.value = val
	};
	
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			const param = groupForm.value;
			param['prvId'] = prvObj.value == '' ? prvId.value : parseInt(prvObj.value.key);
			param['cityId'] = cityObj.value == '' ? cityId.value : parseInt(cityObj.value.key);
			param['districtId'] = districtObj.value == '' ? districtId.value : parseInt(districtObj.value.key);
			param['prv'] = prvObj.value == '' ? prv.value : prvObj.value.value;
			param['city'] = cityObj.value == '' ? city.value : cityObj.value.value;
			param['district'] = districtObj.value == '' ? district.value : districtObj.value.value;
			param['crmIndustry'] = selectedIndustry.value;
			param['isPromoEmail'] = groupForm.value.is_promo_email ? 1:0;
			updateInfo(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					location.reload()
				}
			})
	    } else {
	      return false;
	    }
	  });
	};
	
	onMounted(() => {
		getUserInfoF()
	});
	
	
</script>

<style lang="scss" scoped>
	.ul-industry{
		li{
			float: left;
			border: 1px solid #ddd;
			height: 30px;
			line-height: 30px;
			position: relative;
			padding: 0 20px;
			margin: 0 10px 5px 0;
			width: 162px;
			cursor: pointer;
		}
		.active{color: #015BFE;border-color: #015BFE;background: url(../../assets/images/active.png) right bottom no-repeat;}
	}
	.tip{color: #666; font-size: 13px; margin-left: 10px;}
</style>